import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EpitkezesFlow = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    location: '',
    size: '',
    style: '',
    technology: ''
  });

  const technologies = [
    {
      id: 'modular',
      name: 'Moduláris',
      price: '320.000 Ft/m²-től',
      time: '3-4 hónap',
      icon: '🏗️',
      features: ['Gyors építés', 'Modern design', 'Energiatakarékos']
    },
    {
      id: 'light',
      name: 'Könnyűszerkezetes',
      price: '280.000 Ft/m²-től',
      time: '4-5 hónap',
      icon: '🏡',
      features: ['Költséghatékony', 'Rugalmas tervezés', 'Jó hőszigetelés']
    },
    {
      id: 'traditional',
      name: 'Hagyományos',
      price: '350.000 Ft/m²-től',
      time: '6-8 hónap',
      icon: '🏘️',
      features: ['Tartós', 'Klasszikus', 'Értékálló']
    }
  ];

  const styles = [
    { id: 'modern', name: 'Modern', icon: '🏢' },
    { id: 'classic', name: 'Klasszikus', icon: '🏛️' },
    { id: 'premium', name: 'Prémium', icon: '💎' },
    { id: 'investment', name: 'Befektetésre', icon: '💰' }
  ];

  const sizes = [
    { id: '50-80', name: '50–80 m²', price: '16-25M Ft' },
    { id: '80-120', name: '80–120 m²', price: '25-38M Ft' },
    { id: '120-180', name: '120–180 m²', price: '38-57M Ft' },
    { id: '180+', name: '180+ m²', price: '57M Ft+' }
  ];

  const handleSubmit = () => {
    console.log('Form data:', formData);
    navigate('/kapcsolat', { state: { type: 'epitkezes', data: formData } });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Progress */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            {[1, 2, 3, 4].map((s) => (
              <div
                key={s}
                className={`flex-1 h-2 rounded-full mx-1 ${
                  s <= step ? 'bg-green-500' : 'bg-gray-700'
                }`}
              />
            ))}
          </div>
          <p className="text-gray-400 text-sm text-center">
            {step}. lépés / 4
          </p>
        </div>

        {/* Step 1: Location */}
        {step === 1 && (
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-8 border-2 border-white/[0.08]">
            <h2 className="text-3xl font-black text-white mb-6">
              Hol található a telek?
            </h2>
            <input
              type="text"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              placeholder="Pl. Budapest, XIII. kerület"
              className="w-full bg-white/10 border-2 border-white/[0.08] rounded-xl px-6 py-4 text-white placeholder-gray-400 focus:border-green-500 focus:outline-none mb-6"
            />
            <button
              onClick={() => setStep(2)}
              disabled={!formData.location}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-emerald-600 hover:to-green-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-black py-4 rounded-xl transition-all"
            >
              Következő →
            </button>
          </div>
        )}

        {/* Step 2: Size */}
        {step === 2 && (
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-8 border-2 border-white/[0.08]">
            <h2 className="text-3xl font-black text-white mb-6">
              Mekkora házat szeretnél?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              {sizes.map((size) => (
                <button
                  key={size.id}
                  onClick={() => setFormData({ ...formData, size: size.id })}
                  className={`p-6 rounded-xl border-2 transition-all ${
                    formData.size === size.id
                      ? 'border-green-500 bg-green-500/20'
                      : 'border-white/[0.08] hover:border-white/40'
                  }`}
                >
                  <div className="text-2xl font-black text-white mb-2">{size.name}</div>
                  <div className="text-gray-300">{size.price}</div>
                </button>
              ))}
            </div>
            <div className="flex gap-4">
              <button
                onClick={() => setStep(1)}
                className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-all"
              >
                ← Vissza
              </button>
              <button
                onClick={() => setStep(3)}
                disabled={!formData.size}
                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-emerald-600 hover:to-green-500 disabled:opacity-50 text-white font-black py-4 rounded-xl transition-all"
              >
                Következő →
              </button>
            </div>
          </div>
        )}

        {/* Step 3: Style */}
        {step === 3 && (
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-8 border-2 border-white/[0.08]">
            <h2 className="text-3xl font-black text-white mb-6">
              Milyen stílust szeretnél?
            </h2>
            <div className="grid grid-cols-2 gap-4 mb-6">
              {styles.map((style) => (
                <button
                  key={style.id}
                  onClick={() => setFormData({ ...formData, style: style.id })}
                  className={`p-6 rounded-xl border-2 transition-all ${
                    formData.style === style.id
                      ? 'border-green-500 bg-green-500/20'
                      : 'border-white/[0.08] hover:border-white/40'
                  }`}
                >
                  <div className="text-4xl mb-2">{style.icon}</div>
                  <div className="text-lg font-bold text-white">{style.name}</div>
                </button>
              ))}
            </div>
            <div className="flex gap-4">
              <button
                onClick={() => setStep(2)}
                className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-all"
              >
                ← Vissza
              </button>
              <button
                onClick={() => setStep(4)}
                disabled={!formData.style}
                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-emerald-600 hover:to-green-500 disabled:opacity-50 text-white font-black py-4 rounded-xl transition-all"
              >
                Következő →
              </button>
            </div>
          </div>
        )}

        {/* Step 4: Technology */}
        {step === 4 && (
          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-2xl p-8 border-2 border-white/[0.08]">
            <h2 className="text-3xl font-black text-white mb-6">
              Válassz építési technológiát
            </h2>
            <div className="space-y-4 mb-6">
              {technologies.map((tech) => (
                <button
                  key={tech.id}
                  onClick={() => setFormData({ ...formData, technology: tech.id })}
                  className={`w-full p-6 rounded-xl border-2 transition-all text-left ${
                    formData.technology === tech.id
                      ? 'border-green-500 bg-green-500/20'
                      : 'border-white/[0.08] hover:border-white/40'
                  }`}
                >
                  <div className="flex items-start gap-4">
                    <div className="text-4xl">{tech.icon}</div>
                    <div className="flex-1">
                      <h3 className="text-xl font-black text-white mb-2">{tech.name}</h3>
                      <div className="flex gap-4 mb-3">
                        <span className="text-green-400 font-bold">{tech.price}</span>
                        <span className="text-gray-400">{tech.time}</span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {tech.features.map((feature, idx) => (
                          <span key={idx} className="bg-white/10 text-gray-300 text-xs px-3 py-1 rounded-full">
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
            <div className="flex gap-4">
              <button
                onClick={() => setStep(3)}
                className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-all"
              >
                ← Vissza
              </button>
              <button
                onClick={handleSubmit}
                disabled={!formData.technology}
                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-emerald-600 hover:to-green-500 disabled:opacity-50 text-white font-black py-4 rounded-xl transition-all"
              >
                Ajánlat kérése 🚀
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EpitkezesFlow;
